export default {
  frontRoutes: [
    {
      path: "/index/rec-classes",
      name: "IndexRecommendClasses",
      component: () =>
        import(
          /* webpackChunkName: "classes" */ "../views/classes/Classes.vue"
        ),
    },
    {
      path: "/classes",
      name: "Classes",
      component: () =>
        import(
          /* webpackChunkName: "classes" */ "../views/classes/Classes.vue"
        ),
    },
    {
      path: "/classes/coupon",
      name: "ClassesCoupon",
      component: () =>
        import(
          /* webpackChunkName: "classes" */ "../views/classes/ClassesCoupon.vue"
        ),
    },
    {
      path: "/classes/:id",
      name: "ClassesDetail",
      component: () =>
        import(
          /* webpackChunkName: "classes" */ "../views/classes/ClassesDetail.vue"
        ),
    },
    {
      path: "/member/classes/:id",
      name: "MemberClassesDetail",
      component: () =>
        import(
          /* webpackChunkName: "classes" */ "../views/classes/MemberClassesDetail.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
  ],
  memberRoutes: [
    {
      path: "/member/classes",
      name: "MemberClasses",
      component: () =>
        import(
          /* webpackChunkName: "classes" */ "../views/classes/MemberClasses.vue"
        ),
      meta: {
        requireAuth: true,
        title: "我的班级",
        root: true,
      },
    },
  ],
};
